class HookRegistry {

    constructor() {
        this._hooks = []
    }

    /**
     *
     *
     * @param type
     * @param hookClass
     */
    addHook(type, hookClass) {
        this._hooks.push({
            type,
            class: hookClass
        })
    }

    /**
     * Get all registered hooks by type
     *
     * @param {string} type
     * @returns {array<*>}
     */
    getHooks(type) {
        return this._hooks.filter((hook) => hook.type === type)
    }
}

export {HookRegistry}
